import api from './client';

export const adminApi = {
  duplicateRecordType: (id, data) => api.post(`/admin/record-types/${id}/duplicate`, data),
  // Record Types
  getRecordTypes: () => api.get('/admin/record-types'),
  createRecordType: (data) => api.post('/admin/record-types', data),
  getRecordType: (id) => api.get(`/admin/record-types/${id}`),
  updateRecordType: (id, data) => api.put(`/admin/record-types/${id}`, data),
  deleteRecordType: (id) => api.delete(`/admin/record-types/${id}`),

  // Fields
  getFields: (recordTypeId) => api.get(`/admin/fields?record_type_id=${recordTypeId}`),
  createField: (data) => api.post('/admin/fields', data),
  updateField: (id, data) => api.put(`/admin/fields/${id}`, data),
  deleteField: (id) => api.delete(`/admin/fields/${id}`),

  // Field Groups
  getFieldGroups: (recordTypeId) => api.get(`/admin/fields/groups/list?record_type_id=${recordTypeId}`),
  createFieldGroup: (data) => api.post('/admin/fields/groups', data),
  deleteFieldGroup: (id) => api.delete(`/admin/fields/groups/${id}`),

  // Screens
  getScreens: (recordTypeId) => api.get(`/admin/screens?record_type_id=${recordTypeId}`),
  createScreen: (data) => api.post('/admin/screens', data),
  getScreen: (id) => api.get(`/admin/screens/${id}`),
  updateScreen: (id, data) => api.put(`/admin/screens/${id}`, data),
  deleteScreen: (id) => api.delete(`/admin/screens/${id}`),
  updateScreenLayout: (id, layout) => api.put(`/admin/screens/${id}/layout`, { layout }),
  duplicateScreen: (id) => api.post(`/admin/screens/${id}/duplicate`),
  renderRecord: (recordId, stageId) => api.get(`/admin/screens/render/${recordId}` + (stageId ? `?stageId=${stageId}` : '')),

  // Tenant
  getTenant: () => api.get('/tenant'),
  updateTenant: (data) => api.put('/tenant', data),
  getTemplates: () => api.get('/tenant/templates'),

  // Users
  getUsers: () => api.get('/admin/users'),

  // Workflows
  getWorkflows: (recordTypeId) => api.get('/admin/workflows?record_type_id=' + recordTypeId),
  getWorkflow: (id) => api.get('/admin/workflows/' + id),
  createWorkflow: (data) => api.post('/admin/workflows', data),
  updateWorkflow: (id, data) => api.put('/admin/workflows/' + id, data),
  copyWorkflow: (id, name) => api.post('/admin/workflows/' + id + '/copy', { name }),
  deleteWorkflow: (id) => api.delete('/admin/workflows/' + id),
  addWorkflowStage: (wfId, data) => api.post('/admin/workflows/' + wfId + '/stages', data),
  updateWorkflowStage: (wfId, sId, data) => api.put('/admin/workflows/' + wfId + '/stages/' + sId, data),
  deleteWorkflowStage: (wfId, sId) => api.delete('/admin/workflows/' + wfId + '/stages/' + sId),
  reorderWorkflowStages: (wfId, stageIds) => api.put('/admin/workflows/' + wfId + '/stages/reorder', { stage_ids: stageIds }),
  reorderFields: (fields) => api.put('/admin/fields/actions/reorder', { fields }),
  addWorkflowTransition: (wfId, data) => api.post('/admin/workflows/' + wfId + '/transitions', data),
  updateWorkflowTransition: (wfId, tId, data) => api.put('/admin/workflows/' + wfId + '/transitions/' + tId, data),
  deleteWorkflowTransition: (wfId, tId) => api.delete('/admin/workflows/' + wfId + '/transitions/' + tId),
  // Stage Screens (tabbed)
  getStageScreens: (wfId, stageId) => api.get('/admin/workflows/' + wfId + '/stages/' + stageId + '/screens'),
  addStageScreen: (wfId, stageId, data) => api.post('/admin/workflows/' + wfId + '/stages/' + stageId + '/screens', data),
  updateStageScreen: (wfId, stageId, ssId, data) => api.put('/admin/workflows/' + wfId + '/stages/' + stageId + '/screens/' + ssId, data),
  deleteStageScreen: (wfId, stageId, ssId) => api.delete('/admin/workflows/' + wfId + '/stages/' + stageId + '/screens/' + ssId),
  // Task Templates
  getWorkflowStages: (wfId) => api.get('/admin/workflows/' + wfId).then(res => ({ data: { stages: res.data.workflow.stages } })),
  getTaskTemplates: (wfId, stageId) => api.get('/admin/workflows/' + wfId + '/stages/' + stageId + '/task-templates'),
  createTaskTemplate: (wfId, stageId, data) => api.post('/admin/workflows/' + wfId + '/stages/' + stageId + '/task-templates', data),
  updateTaskTemplate: (wfId, stageId, id, data) => api.put('/admin/workflows/' + wfId + '/stages/' + stageId + '/task-templates/' + id, data),
  deleteTaskTemplate: (wfId, stageId, id) => api.delete('/admin/workflows/' + wfId + '/stages/' + stageId + '/task-templates/' + id),
  // Staging Users
  getStagingUsers: () => api.get('/admin/staging'),
  getStagingTenants: () => api.get('/admin/staging/tenants'),
  getStagingRoles: (tenantId) => api.get('/admin/staging/roles/' + tenantId),
  assignStagingUser: (userId, data) => api.post('/admin/staging/' + userId + '/assign', data),
  approveStagingTenant: (userId, data) => api.post('/admin/staging/' + userId + '/approve-tenant', data),
  deleteStagingUser: (userId) => api.delete('/admin/staging/' + userId),
  cleanupOrphans: () => api.post('/admin/staging/cleanup-orphans'),

  // Workflow-to-Workflow Transitions
  getWorkflowTransitions: (rtId) => api.get('/admin/workflows/workflow-transitions/' + rtId),
  createWorkflowTransition: (rtId, data) => api.post('/admin/workflows/workflow-transitions/' + rtId, data),
  updateWorkflowTransition2: (rtId, tId, data) => api.put('/admin/workflows/workflow-transitions/' + rtId + '/' + tId, data),
  deleteWorkflowTransition2: (rtId, tId) => api.delete('/admin/workflows/workflow-transitions/' + rtId + '/' + tId),

  // Teams (Part 3A)
  listTeams: () => api.get('/admin/teams'),
  createTeam: (data) => api.post('/admin/teams', data),
  updateTeam: (id, data) => api.put('/admin/teams/' + id, data),
  deleteTeam: (id) => api.delete('/admin/teams/' + id),
  getTeamReferences: (id) => api.get('/admin/teams/' + id + '/references'),
  listTeamMembers: (id) => api.get('/admin/teams/' + id + '/members'),
  addTeamMember: (teamId, data) => api.post('/admin/teams/' + teamId + '/members', data),
  updateTeamMember: (teamId, userId, data) => api.put('/admin/teams/' + teamId + '/members/' + userId, data),
  removeTeamMember: (teamId, userId) => api.delete('/admin/teams/' + teamId + '/members/' + userId),

};


// Workflow Templates
export const workflowTemplatesApi = {
  list: (practiceArea) => api.get('/workflow-templates', { params: { practice_area: practiceArea } }).then(r => r.data),
  get: (id) => api.get('/workflow-templates/' + id).then(r => r.data),
  preview: (id, recordTypeId) => api.post('/workflow-templates/' + id + '/preview', { record_type_id: recordTypeId }).then(r => r.data),
  install: (id, recordTypeId, fieldResolutions, recordTypeName) => api.post('/workflow-templates/' + id + '/install', { record_type_id: recordTypeId, field_resolutions: fieldResolutions, record_type_name: recordTypeName }).then(r => r.data),
  installed: (recordTypeId) => api.get('/workflow-templates/installed/' + recordTypeId).then(r => r.data),
  saveFromWorkflow: (data) => api.post('/workflow-templates/save-from-workflow', data).then(r => r.data),
  setDefault: (workflowId, recordTypeId) => api.post('/workflow-templates/set-default', { workflow_id: workflowId, record_type_id: recordTypeId }),
  uninstall: (installId) => api.delete('/workflow-templates/installs/' + installId).then(r => r.data),
};
